module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-sm-1\">\r\n        <div style=\"margin-top: 5px\">Title</div>\r\n    </div>\r\n    <div class=\"col-sm-11\">\r\n        <input type=\"text\" name=\"title\" class=\"title\" value=\"")
    ; __append(escapeFn(title))
    ; __append("\" />\r\n    </div>\r\n</div>")
  }
  return __output;

}